import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function RequireAdmin() {
  const { isAuthenticated, booting } = useAdminAuth();
  const location = useLocation();

  if (booting) {
    return (
      <div className="admin-shell flex min-h-screen items-center justify-center">
        <p className="admin-mono text-sm text-[#94a3b8]">Checking session…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
